<template>
<VBtn
  class="documentation-button-component text--text"
  :color="color"
  :href="href"
  target="_blank"
  :small="small"
  >
  {{ label }} <KmIcon :size="18" name="km-icon-support" class="ml-2" />
</VBtn>
</template>

<script>
import KmIcon from '@/components/KmIcon'
import isAbsoluteURL from '@/utils/isAbsoluteURL'

export default {
  name: 'DocumentationButton',
  components: {
    KmIcon,
  },
  props: {
    color: {
      type: String,
      default: 'info'
    },
    path: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Documentation',
    },
    small: Boolean,
  },
  computed: {
    href() {
      if (this.path === '') return 'http://doc.pm2.io/'
      if (isAbsoluteURL(this.path)) return this.path
      return `http://doc.pm2.io/en/${this.path}`
    },
  },
}
</script>

<style lang="postcss" scoped>
.documentation-button-component {
  margin: 0;
}
.v-btn--small {
  text-transform: none;
  height: 20px;
}
</style>
